import React from "react";
import Tabs from "@material-ui/core/Tabs";
import PropTypes from "prop-types";
import Tab from "@material-ui/core/Tab";
import EBagList from "./partials/EBagList";
import SingleEbag from "./partials/SingleEbag";
import { createClientPanelEbag, showModal } from "@actions";
import { connect } from "react-redux";

const EBag = (props) => {
  const tabs = [{ key: "ebagList", label: "eBag List" }];

  const [activeTab, setActiveTab] = React.useState(0);

  const handleTabChange = (event, newTab) => {
    setActiveTab(newTab);
  };

  return (
    <React.Fragment>
      <div className="top-menu">
        <Tabs
          value={activeTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleTabChange}
        >
          {tabs.map((tab) => {
            return <Tab key={tab.key} label={tab.label} />;
          })}
        </Tabs>
        {tabs[activeTab].key === "ebagList" && (
          <button
            type="button"
            className="btn create rounded"
            onClick={() =>
              props.showModal(
                <SingleEbag
                  item={{}}
                  mode="create"
                  onSave={(data) => {
                    return props.createClientPanelEbag(props.event.id, {
                      ...data,
                      index:
                        props.event.clientPanelSettings.ebag.ebagSchema.length,
                    });
                  }}
                />
              )
            }
          >
            Create
          </button>
        )}
      </div>
      {tabs[activeTab].key === "ebagList" && <EBagList />}
    </React.Fragment>
  );
};

EBag.propTypes = {
  event: PropTypes.object,
  createClientPanelEbag: PropTypes.func,
  showModal: PropTypes.func,
  index: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    event: state.api.events.edit.data,
    fetching: state.api.events.edit.fetching,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showModal: (content) => dispatch(showModal(content)),
    createClientPanelEbag: (eventId, data) => {
      return dispatch(createClientPanelEbag(eventId, data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EBag);
